(() => {

  const configLabel = 'Google Gtag Pixel';
  const gaConfig = window?.ShopifyAnalytics?.lib?.config[configLabel];
  const gaPropertyID = gaConfig?.conversionId;
  const gaTargetCountry = gaConfig?.targetCountry;
  const gaCurrency = window?.Shopify?.currency?.active || window?.ShopifyAnalytics?.meta?.currency || 'EUR';

  const generateProductIds = (items) => items.map((item) => "shopify_" + gaTargetCountry + "_" + item.id + "_" + item.variant_id);

  const getItemsValue = (items) => {
    let total = 0;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const quantity = parseInt(item.quantity);
      const price = parseFloat(item.price, 2);
      total += price * quantity;
    }
    return total;
  }

  const handleEvent = ({ type, items, collection }) => {
    let payload = {
      send_to: gaPropertyID
    };

    if (type === 'view_cart') {
      payload = {
        ...payload,
        ecomm_totalvalue: getItemsValue(items),
        ecomm_pagetype: "cart",
        value: getItemsValue(items),
        currency: gaCurrency,
        items,
      };
    }

    if (type === 'view_item_list' || type === 'select_item') {
      payload = {
        ...payload,
        item_list_id: collection.id,
        item_list_name: collection.title,
        items,
      };
    }

    if (type === 'add_to_cart' || type === 'remove_from_cart') {
      payload = {
        ...payload,
        ecomm_prodid: generateProductIds(items),
        ecomm_totalvalue: getItemsValue(items),
        ecomm_pagetype: "cart",
        value: getItemsValue(items),
        currency: gaCurrency,
        items,
      };
    }
    
    window.gtag = window.gtag || function() { dataLayer.push(arguments) };
    
    gtag('event', type, payload);
  }

  const getProductsJson = ({ context = document, selector = '[data-ga-product-json]', lineItemQuantity }) => {
    const items = [...context.querySelectorAll(selector)].map(el => {
      try {
        const product = JSON.parse(el.innerHTML);
        return product;
      } catch (error) { 
      }
    }).filter(p => p);

    if (items && items.length === 1 && items[0]?.quantity && lineItemQuantity) {
      items[0].quantity = lineItemQuantity;
    }
    
    return items;
  }

  const getCollectionJson = ({ context = document, selector = '[data-ga-collection-json]' }) => {
    const script = context.querySelector(selector);

    try {
      const collection = JSON.parse(script.innerHTML);
      return collection;
    } catch (error) { }

    return {};
  }

  const getSectionElement = (html, selector = '.shopify-section') => {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  const fetchItemsByCartSection = async () => {
    const sectionName = 'ga-products-json';
    const sectionRendered = await fetch(`/cart?sections=${sectionName}`).then(r=>r.json());
    if (sectionRendered && sectionRendered[sectionName]) {
      const section = getSectionElement(sectionRendered[sectionName]);
      const items = getProductsJson({ context: section });
      return items;
    }
    return [];
  }

  const fetchProductContextJson = async ({ productHandle, variantId, lineItemQuantity }) => {
    const sectionName = 'ga-product-json';
    const sectionRendered = await fetch(`/products/${productHandle}?variant=${variantId}&sections=${sectionName}`).then(r=>r.json());
    if (sectionRendered && sectionRendered[sectionName]) {
      const section = getSectionElement(sectionRendered[sectionName]);
      const items = getProductsJson({ context: section, lineItemQuantity });
      return items;
    }
    return [];
  }

  const bindEvents = () => {
    // small delay to catch repainting of new HTML
    setTimeout(() => {
      document.querySelectorAll('[ga-type]').forEach((el) => {
        const attached = el.hasAttribute('ga-event-attached') && el.getAttribute('ga-event-attached') || undefined;
        const type = el.hasAttribute('ga-type') && el.getAttribute('ga-type') || undefined;
        const action = el.hasAttribute('ga-action') && el.getAttribute('ga-action') || undefined;
        const intercept = el.hasAttribute('ga-intercept') && el.getAttribute('ga-intercept') === 'true' || undefined;
        const variantId = el.hasAttribute('ga-variant-id') && el.getAttribute('ga-variant-id') || undefined;
        const productHandle = el.hasAttribute('ga-product-handle') && el.getAttribute('ga-product-handle') || undefined;
        const lineItemQuantity = el.hasAttribute('ga-line-item-quantity') && el.getAttribute('ga-line-item-quantity') || undefined;
    
        if (!attached) {
          el.setAttribute('ga-event-attached', true);
    
          if (action && action === 'click') {
            el.addEventListener('click', async (e) => {
              // if (intercept) {
              //   e.preventDefault();
              // }
              let items;
              if (productHandle, variantId, lineItemQuantity) {
                items = await fetchProductContextJson({ productHandle, variantId, lineItemQuantity });
              }
              if (type === "view_cart") {
                if (e.target.getAttribute('aria-expanded') === 'true') {
                  return;
                }
                items = await fetchItemsByCartSection();
              }
              handleEvent({ type, items });
            });
          }
  
          if (action && action === 'view') {
            const observer = new IntersectionObserver((entries, observer) => { 
              entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                let items, collection;
                console.log(type);
                if (type === "view_cart") {
                  items = await fetchItemsByCartSection();
                } else {
                  items = getProductsJson({ context: entry.target, selector: '[data-ga-product-json]' });
                }
                if (type === "view_item_list") {
                  collection = getCollectionJson({ context: entry.target, selector: '[data-ga-collection-json]' });
                }
                handleEvent({ context: entry.target, type, items, collection });
                if (type === "view_item_list") {
                  entry.target.querySelectorAll('a').forEach(anchor => {
                    const REGEX_PRODUCT_LINK = new RegExp(/\/products\//i);
                    if (REGEX_PRODUCT_LINK.test(anchor.getAttribute('href'))) {
                      const context = anchor.closest('.product') || anchor.closest('.product-item') || anchor.closest('.product-card');
                      if (context) {
                        const anchorItems = getProductsJson({ context, selector: '[data-ga-product-json]' });
                        if (anchorItems && anchorItems.length) {
                          anchor.addEventListener('click', () => {
                            return handleEvent({ context, type: 'select_item', items: anchorItems, collection });
                          });
                        }
                      }
                    }
                  });
                }
                observer.unobserve(entry.target);
              }
              });
            }, {rootMargin: "0px 0px -200px 0px"});
            observer.observe(el);
          }
        }
      });
    }, 500);
  }

  document.addEventListener('theme:loading:end', bindEvents);
  window.addEventListener('DOMContentLoaded', bindEvents);
  // document.addEventListener('theme:loading:end', console.log);

})();